import { z } from "zod";
import { RequestMagicLinkSchema, RequestFileDtoSchema } from "request-form-lib";

export const ReadableRequestParameterSchema = z.object({
    section: z.string().nullish(),
    label: z.string().nullish(),
    value: z.string().nullish(),
});

export const GetMagicLinkDataOutputSchema = z.object({
    expire: z.boolean().nullish(),
    linkData: RequestMagicLinkSchema.nullish(),
    readableRequestParameters: z.array(ReadableRequestParameterSchema).nullish(),
    requestFiles: z.array(RequestFileDtoSchema).nullish(),
    idCardFrontUploaded: z.boolean().nullish(),
    idCardBackUploaded: z.boolean().nullish(),
    requestTypeName: z.string().nullish(),
});

export type GetMagicLinkDataOutput = z.infer<typeof GetMagicLinkDataOutputSchema>;
